import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';

const NAV = [
  { path: '/dashboard',      icon: '📊', label: 'Dashboard'        },
  { path: '/users',          icon: '👥', label: 'Users'            },
  { path: '/email',          icon: '✉️', label: 'Send Email'        },
  { path: '/admins',         icon: '🛡️', label: 'Admins',  super: true },
  { path: '/templates',      icon: '🎨', label: 'Templates'        },
  { path: '/documents',      icon: '📄', label: 'Documents'        },
  { path: '/announcements',  icon: '📢', label: 'Announcements'    },
  { path: '/about',          icon: '🏢', label: 'About Us'         },
  { path: '/blog',           icon: '✍️', label: 'Blog'             },
  { path: '/sections',       icon: '🔒', label: 'Premium Sections' },
  { path: '/referrals',      icon: '🎁', label: 'Referrals'        },
  { path: '/interviews',     icon: '🎤', label: 'Interviews'       },
  { path: '/feedback',       icon: '💬', label: 'Feedback'         },
  { path: '/settings',       icon: '⚙️', label: 'Settings'         },
];

const s = {
  sidebar: {
    width: 220, background: '#F8FAFC', height: '100vh', display: 'flex',
    flexDirection: 'column', borderRight: '1px solid #E2E8F0', flexShrink: 0,
    position: 'fixed', left: 0, top: 0, zIndex: 100,
  },
  logo: {
    padding: '20px 20px 16px', borderBottom: '1px solid #E2E8F0',
    display: 'flex', alignItems: 'center', gap: 10,
  },
  navItem: (active) => ({
    display: 'flex', alignItems: 'center', gap: 10, padding: '10px 18px',
    color: active ? '#C5161D' : '#64748B', background: active ? '#FFF1E8' : 'transparent',
    borderRadius: 8, margin: '2px 8px', cursor: 'pointer', fontSize: 13,
    fontWeight: active ? 600 : 400, transition: 'all 0.15s', textDecoration: 'none',
    border: active ? '1px solid #FDBA74' : '1px solid transparent',
  }),
  main: { marginLeft: 220, minHeight: '100vh', background: '#F8FAFC', flex: 1 },
  topbar: {
    background: '#FFFFFF', borderBottom: '1px solid #E2E8F0', padding: '0 24px',
    height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    position: 'sticky', top: 0, zIndex: 50,
  },
};

export const AdminLayout = ({ children }) => {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const visibleNav = NAV.filter(n => !n.super || admin?.role === 'superadmin');

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <div style={s.sidebar}>
        <div style={s.logo}>
          <img src="/assets/mars-logo.png" alt="MarsResume logo" style={{ width: 34, height: 34, objectFit: 'contain', display: 'block' }} />
          <div>
            <div style={{ color: '#0F172A', fontWeight: 800, fontSize: 14 }}>MarsResume</div>
            <div style={{ color: '#64748B', fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>Admin Panel</div>
          </div>
        </div>

        <nav style={{ flex: 1, padding: '12px 0', overflowY: 'auto' }}>
          {visibleNav.map(item => {
            const active = location.pathname === item.path;
            return (
              <div key={item.path} style={s.navItem(active)} onClick={() => navigate(item.path)}>
                <span style={{ fontSize: 15 }}>{item.icon}</span>
                <span>{item.label}</span>
                {item.super && <span style={{ marginLeft: 'auto', fontSize: 9, background: '#FB923C', color: 'white', padding: '1px 5px', borderRadius: 4 }}>SA</span>}
              </div>
            );
          })}
        </nav>

        <div style={{ borderTop: '1px solid #E2E8F0', padding: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', marginBottom: 6 }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg,#EF1D28,#FB923C)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700, fontSize: 13, flexShrink: 0 }}>
              {admin?.name?.charAt(0).toUpperCase()}
            </div>
            <div style={{ overflow: 'hidden' }}>
              <div style={{ color: '#0F172A', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{admin?.name}</div>
              <div style={{ fontSize: 10, color: '#FB923C', fontWeight: 700, textTransform: 'uppercase' }}>{admin?.role}</div>
            </div>
          </div>
          <button onClick={logout} style={{ width: '100%', background: '#FFFFFF', color: '#64748B', border: '1px solid #E2E8F0', borderRadius: 6, padding: '7px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
            Sign Out
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={s.main}>
        <div style={s.topbar}>
          <div style={{ color: '#64748B', fontSize: 13 }}>
            {visibleNav.find(n => n.path === location.pathname)?.label || 'Admin Panel'}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <a href="/" target="_blank" rel="noreferrer" style={{ color: '#15803D', fontSize: 12, fontWeight: 600, textDecoration: 'none', background: '#DCFCE7', padding: '4px 10px', borderRadius: 6, border: '1px solid #BBF7D0' }}>
              🌐 View Site
            </a>
            <span style={{ color: '#64748B', fontSize: 12 }}>{new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</span>
          </div>
        </div>
        <div style={{ padding: 24 }}>{children}</div>
      </div>
    </div>
  );
};
